import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              Shock Growth Partners
            </h3>
            <p className="text-sm text-gray-400 mb-6 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
              Delivering transformative business solutions in partnership with Chameleon Collective. We combine strategic expertise with innovative execution to drive measurable results for forward-thinking organizations.
            </p>
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/in/tom-shock/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                {isHomePage ? (
                  <button
                    onClick={() => scrollToSection('home')}
                    className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Home
                  </button>
                ) : (
                  <Link
                    to="/"
                    className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Home
                  </Link>
                )}
              </li>
              <li>
                {isHomePage ? (
                  <button
                    onClick={() => scrollToSection('affiliation')}
                    className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Affiliation
                  </button>
                ) : (
                  <Link
                    to="/#affiliation"
                    className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Affiliation
                  </Link>
                )}
              </li>
              <li>
                {isHomePage ? (
                  <button
                    onClick={() => scrollToSection('services')}
                    className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Services
                  </button>
                ) : (
                  <Link
                    to="/#services"
                    className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Services
                  </Link>
                )}
              </li>
              <li>
                <Link
                  to="/articles"
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  Articles
                </Link>
              </li>
              <li>
                {isHomePage ? (
                  <button
                    onClick={() => scrollToSection('contact')}
                    className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Contact
                  </button>
                ) : (
                  <Link
                    to="/#contact"
                    className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Contact
                  </Link>
                )}
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
              Contact Info
            </h4>
            <ul className="space-y-3">
              <li className="text-sm text-gray-400" style={{ fontFamily: "'Inter', sans-serif" }}>
                tom.shock@chameleon.co
              </li>
              <li className="text-sm text-gray-400" style={{ fontFamily: "'Inter', sans-serif" }}>
                612-309-1931
              </li>
              <li className="text-sm text-gray-400" style={{ fontFamily: "'Inter', sans-serif" }}>
                Monday - Friday
                <br />
                8:00 AM - 5:00 PM CST
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400" style={{ fontFamily: "'Inter', sans-serif" }}>
              © 2025 Shock Growth Partners. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}